var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "60px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,511.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4597.4,4993c-92.1-9.8-268.5-41.2-392-68.6c-1264.1-284.2-2285.1-1230.8-2655.5-2465.4c-119.5-395.9-139.1-552.7-139.1-1099.5c2-507.6,21.6-703.6,111.7-1117.1C1887-1433.2,3060.9-3204.9,4752.2-4627.7c245-205.8,227.3-201.9,395.9-66.6C6427.8-3661.5,7572.4-2183.8,8117.2-857c429.2,1044.6,576.2,2146,397.8,2998.5C8238.7,3480,7211.8,4559.8,5898.7,4896.9C5520.5,4994.9,4965.8,5036.1,4597.4,4993z M5420.5,4218.8c531.1-90.2,1038.7-344.9,1434.6-713.4c339-317.5,595.8-709.5,742.8-1136.7c92.1-264.6,133.3-493.9,147-803.5c31.4-811.3-254.8-1534.5-832.9-2108.7c-392-388-899.6-654.6-1464-764.3c-243-49-756.5-49-999.5,0C3292.2-1080.5,2441.6-239.7,2190.7,920.5c-50.9,233.2-49,840.7,2,1075.9c123.5,570.3,368.4,1023,776.1,1432.6c456.6,456.6,960.3,709.4,1626.6,809.4C4740.4,4260,5252,4248.2,5420.5,4218.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4080,2658.8l-895.6-672.2l245-5.9l243-5.9l5.9-997.5l5.9-999.5l64.7-62.7l62.7-64.7h1175.9h1175.9l62.7,64.7l64.7,62.7l5.9,999.5l5.9,997.5l243,5.9l245,5.9L5906.5,2649c-486,364.5-893.7,666.3-907.4,672.2C4987.4,3325.2,4571.9,3027.3,4080,2658.8z M5438.1,1751.4c105.8-54.9,117.6-105.8,117.6-529.1c0-568.3,9.8-558.5-558.5-558.5c-570.3,0-558.5-11.8-558.5,558.5c0,570.3-13.7,556.6,554.6,558.5C5302.9,1780.8,5393.1,1775,5438.1,1751.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapHome);
export default __webpack_public_path__ + "static/media/map_home.b88648dbf7ef4f97da5e7ae50bb1405f.svg";
export { ForwardRef as ReactComponent };